import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import type { ObjectValues } from "@/src/shared/types/objectValues";

export const ICON_PICKER_CATEGORY_ID = {
  StatusAndMetrics: "status_and_metrics",
  Actions: "actions",
  FilesAndData: "files_and_data",
  Navigation: "navigation",
  PeopleAndCommunication: "people_and_communication",
  Media: "media",
  Other: "other",
  All: "all",
} as const;

export type IconPickerCategoryId = ObjectValues<typeof ICON_PICKER_CATEGORY_ID>;

export type IconPickerDataCategoryId = Exclude<
  IconPickerCategoryId,
  typeof ICON_PICKER_CATEGORY_ID.All | typeof ICON_PICKER_CATEGORY_ID.Other
>;

export type IconPickerCategoryLabelKey =
  | "statusAndMetrics"
  | "actions"
  | "filesAndData"
  | "navigation"
  | "peopleAndCommunication"
  | "media"
  | "other"
  | "all";

export interface IconPickerCategory {
  id: IconPickerCategoryId;
  labelKey: IconPickerCategoryLabelKey;
  icon?: DSIconName;
}

export const ICON_PICKER_CATEGORIES: readonly IconPickerCategory[] = [
  {
    id: ICON_PICKER_CATEGORY_ID.StatusAndMetrics,
    labelKey: "statusAndMetrics",
    icon: "bell",
  },
  {
    id: ICON_PICKER_CATEGORY_ID.Actions,
    labelKey: "actions",
    icon: "pen",
  },
  {
    id: ICON_PICKER_CATEGORY_ID.FilesAndData,
    labelKey: "filesAndData",
    icon: "document",
  },
  {
    id: ICON_PICKER_CATEGORY_ID.Navigation,
    labelKey: "navigation",
    icon: "arrow-right",
  },
  {
    id: ICON_PICKER_CATEGORY_ID.PeopleAndCommunication,
    labelKey: "peopleAndCommunication",
    icon: "users",
  },
  {
    id: ICON_PICKER_CATEGORY_ID.Media,
    labelKey: "media",
    icon: "video",
  },
  {
    id: ICON_PICKER_CATEGORY_ID.Other,
    labelKey: "other",
    icon: "smile",
  },
  {
    id: ICON_PICKER_CATEGORY_ID.All,
    labelKey: "all",
  },
] as const;
